import * as parse5 from 'parse5';

class HtmlFormatter {
  public format(html: string) {
    const document = parse5.parse(html);
    const formattedHtml = parse5.serialize(document);
    if (!formattedHtml.startsWith('<!DOCTYPE html')) {
      return `<!DOCTYPE html>\r\n${formattedHtml}`;
    }
    return formattedHtml;
  }
}

export const htmlFormatter = new HtmlFormatter();
